import { createStore } from 'redux';
import rootReducer from './modules/rootReducer';

export default createStore(rootReducer);
